<template>
  <div class="detail">
    <el-card>
      <i class="el-icon-back" style="color: #2d8cf0"></i><el-button @click="goBack()">返回</el-button>
      <div class="title">项目名称-控制PSN 调试记录</div>
      <el-table style="width: 100%" ref="basePageTable" :data="rows" :height="offsetWindowHeight" v-loading="searching">
        <el-table-column type="index" label="序号" :index="indexMethod" align="center"></el-table-column>
        <el-table-column prop="time" label="时间" align="center"></el-table-column>
        <el-table-column prop="option" label="操作" align="center"></el-table-column>
        <el-table-column prop="content" label="内容"  align="center"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import BasePage from "@/components/BasePage";
export default {
  name: "detail",
  mixins: [BasePage],
  methods: {
    getRows() {
      this.rows = [
        {
          option: 'syc',
          content: '11111'
        }, {
          option: 'syc',
          content: '11111'
        }, {
          option: 'syc',
          content: '11111'
        }, {
          option: 'syc',
          content: '11111'
        }, {
          option: 'syc',
          content: '11111'
        }, {
          option: 'syc',
          content: '11111'
        }, {
          option: 'syc',
          content: '11111'
        }, {
          option: 'syc',
          content: '11111'
        }, {
          option: 'syc',
          content: '11111'
        }, {
          option: 'syc',
          content: '11111'
        }
      ]
    },
    goBack() {
      this.$router.push('/management/commission')
    }
  }
}
</script>

<style lang="scss" scoped>
.detail{
  width: 100%;
  height: 100%;
  .el-button{
    border: none;
  }
  .title{
    margin: 10px;
  }
}
</style>
